module.exports = __webpack_public_path__ + "static/media/11_2.fd929431.png";